import React, {useEffect, useState} from 'react';
import {startLoadingSpinner, stopLoadingSpinner} from '../../csf-ufc-pivotal/includes/utils';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import {
  convertBase64,
  handleClearFileInput,
  handleFileInput,
  handleFileInputDefault,
  resetErrMessages,
  updateHeadingBasedOnUrl
} from '../includes/utils';
import PropTypes from "prop-types";
import PivotalAttachmentsApi from "../../../js/csf/pivotal/PivotalAttachmentsApi";
import JustValidate from 'just-validate';
import CsfFournisseurRecognitionRenewalTitle
  from "../includes/csf-fournisseur-recognition-renewal-title";

export function FournisseurRecognitionRequestStepThreeBlock({
                                                              hasPreviousRenewalEndDate,
                                                              currentStep,
                                                              onStepChange,
                                                              accessToken,
                                                              apiUrl,
                                                              apiEnv,
                                                              form,
                                                              updateForm
                                                            }) {

  const [files, setFiles] = useState({});
  const [filesBase64, setFilesBase64] = useState({
    'Formation_Plan': '',
    'Evaluation': '',
    'EP_Doc_Comp_1': '',
    'EP_Doc_Comp_2': '',
    'EP_Doc_Comp_3': '',
    'EP_Doc_Comp_4': ''
  });
  const [updateForm3, setUpdateForm3] = useState(false);
  const [isSeparateFile, setIsSeparateFile] = useState(false);
  const [validator, setValidator] = useState(null);
  const [evaluationFileName, setEvaluationFileName] = useState('');
  const [eP_Doc_Comp_1FileName, setEP_Doc_Comp_1FileName] = useState('');
  const [eP_Doc_Comp_2FileName, setEP_Doc_Comp_2FileName] = useState('');
  const [eP_Doc_Comp_3FileName, setEP_Doc_Comp_3FileName] = useState('');
  const [eP_Doc_Comp_4FileName, setEP_Doc_Comp_4FileName] = useState('');
  const [trainingFileName, setTrainingFileName] = useState('');
  const [fileUploaded, setFileUploaded] = useState(false);
  const [lastCycle, setLastCycle] = useState({});
  const [isDifficultyChecked, setIsDifficultyChecked] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const isRenewal = (urlParams.get('renewal') === 'true' || hasPreviousRenewalEndDate);

  /*
  * On components mounts fetch the user access token only once.
  * */
  useEffect(() => {
    handleFileInput();
  }, []);

  /*
  * On components mounts fetch the user access token only once.
  * */
  useEffect(() => {
    if (lastCycle && Object.keys(lastCycle).length > 0) {
      if (lastCycle.Evaluation) {
        setIsSeparateFile(true);
        handleFileInputDefault('Evaluation', lastCycle.Evaluation, lastCycle.RN_Evaluation_FZ);
        setEvaluationFileName(lastCycle.Evaluation);
      } else {
        handleClearFileInput('Evaluation');
      }
      if (lastCycle.EP_Doc_Comp_1) {
        setIsSeparateFile(true);
        handleFileInputDefault('EP_Doc_Comp_1', lastCycle.EP_Doc_Comp_1, lastCycle.RN_EP_Doc_Comp_1_FZ);
        setEP_Doc_Comp_1FileName(lastCycle.EP_Doc_Comp_1);
      } else {
        handleClearFileInput('EP_Doc_Comp_1');
      }
      if (lastCycle.EP_Doc_Comp_2) {
        setIsSeparateFile(true);
        handleFileInputDefault('EP_Doc_Comp_2', lastCycle.EP_Doc_Comp_2, lastCycle.RN_EP_Doc_Comp_2_FZ);
        setEP_Doc_Comp_2FileName(lastCycle.EP_Doc_Comp_2);
      } else {
        handleClearFileInput('EP_Doc_Comp_2');
      }
      if (lastCycle.EP_Doc_Comp_3) {
        setIsSeparateFile(true);
        handleFileInputDefault('EP_Doc_Comp_3', lastCycle.EP_Doc_Comp_3, lastCycle.RN_EP_Doc_Comp_3_FZ);
        setEP_Doc_Comp_3FileName(lastCycle.EP_Doc_Comp_3);
      } else {
        handleClearFileInput('EP_Doc_Comp_3');
      }
      if (lastCycle.EP_Doc_Comp_4) {
        setIsSeparateFile(true);
        handleFileInputDefault('EP_Doc_Comp_4', lastCycle.EP_Doc_Comp_4, lastCycle.RN_EP_Doc_Comp_4_FZ);
        setEP_Doc_Comp_4FileName(lastCycle.EP_Doc_Comp_4);
      } else {
        handleClearFileInput('EP_Doc_Comp_4');
      }
      if (lastCycle.Formation_Plan) {
        handleFileInputDefault('Formation_Plan', lastCycle.Formation_Plan, lastCycle.RN_Formation_Plan_FZ);
        setTrainingFileName(lastCycle.Formation_Plan);
      } else {
        setIsSeparateFile(true);
        handleClearFileInput('Formation_Plan');
      }
      setIsDifficultyChecked(lastCycle.Hard_Questions);
    }

  }, [lastCycle]);

  /*
  * Init the bootstrap tooltips on list change
  * */
  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip({
      customClass: 'sup-tooltip'
    });
    $('[data-toggle="tooltip-wide"]').tooltip({
      delay: {show: 0, hide: 2000},
      customClass: 'wide-tooltip right-arrow'
    });
  });

  /*
  * If update form is changed, mean form is submit so trigger submit function
  * */
  useEffect(() => {
    if (updateForm3 === true) {
      updateForm3Send();
    }
  }, [updateForm3]);


  /*
  * If update form is changed, mean form is submit so trigger submit function
  * */
  useEffect(() => {
    if (form.Cycle__Secondary && form.Cycle__Secondary.length > 0) {

      const lastCycleData = form.Cycle__Secondary.find(cycle => cycle.REDU_Activity__Cycle_Id === form.Last_REDU_Cycle_Id);
      if (lastCycleData) {
        setLastCycle(lastCycleData);
      }
    }
  }, [form]);

  /*
  * Effect for validation
  * */
  useEffect(() => {
    const validator = new JustValidate('#form-step03');

    validator
      .addField('#Formation_Plan_Text', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ])
      .addField('#description', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ])

    if (isDifficultyChecked) {
      validator.addField('#passing-grade', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
        {
          rule: 'minNumber',
          value: 60,
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.minMax'),
        },
        {
          rule: 'maxNumber',
          value: 100,
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.minMax'),
        },
      ])
    }

    if (isRenewal) {
      validator.removeField('#Formation_Plan_Text');
    }

    setValidator(validator);
  }, [isSeparateFile, isDifficultyChecked]);

  /*
  * Method that handle the change of the form title to display something different if it's a renewal or not.
  * */
  useEffect(() => {
    updateHeadingBasedOnUrl("step3", "renewal", window.Drupal.t('fournisseur.creation_form.page.title'), window.Drupal.t('fournisseur.creation_form.page.renew.title'), hasPreviousRenewalEndDate);
  }, [hasPreviousRenewalEndDate]);

  /*
  * handle the click on the next step
  * */
  function handleNextStepClick() {
    onStepChange(currentStep + 1); // Call the callback function with new count
  }

  /*
  * handle the click on the previous step
  * */
  function handlePreviousStepClick() {
    onStepChange(currentStep - 1); // Call the callback function with new count
  }

  function goToSpecificStep(step) {
    onStepChange(step); // Call the callback function with new count
  }

  /*
  * handle the form submission to pivotal
  * */
  function updateForm3Send() {
    const formElement = document.getElementById('form-step03');
    const data = new FormData(formElement);
    const formStep3 = {
      Passing_Grade: form.Condition_With_Evaluation === true ? data.get('passing-grade') : '60',
      Hard_Questions: form.Condition_With_Evaluation === true ? data.get('difficulty-level') === 'on' : false,
      Activity_Participation_Control: data.get('description'),
    };

    let requestData = {
      form: 'CSF_EP_UXRecognition_3_REST',
      recordId: form?.Last_REDU_Cycle_Id,
      deltadata: {...formStep3, ...files}
    };

    startLoadingSpinner();
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload != null) {
          stopLoadingSpinner();
          updateForm();
          console.log("%c Save step 3 successful", 'background: #5E5E5E; color: #0f0');
          handleNextStepClick();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * handle the actual submission button click
  * */
  function submitFormStep3(event) {
    event.preventDefault();

    if (validator) {
      //Reset errors fields
      resetErrMessages();
      document.getElementById("Formation_Plan_Text").classList.remove("just-validate-error-field");
      validator.validate();
      setTimeout(() => {
        if (validator?.isValid) {
          document.getElementById("Formation_Plan_Text").closest(".file-custom").removeAttribute("style");
          if (fileUploaded === true) {
            uploadDocuments();
          } else { // no documents was changed
            setUpdateForm3(true);
          }
        } else {
          console.error('Form validation failed!');
          document.getElementById("Formation_Plan_Text").closest(".file-custom").removeAttribute("style");
          if (document.getElementById("Formation_Plan_Text").classList.contains("just-validate-error-field") && document.getElementById("Formation_Plan_Text").value.length === 0) {
            document.getElementById("Formation_Plan_Text").closest(".file-custom").style.cssText = "border: 1px solid red; margin-bottom: 1.6rem";
          }
        }
      });
    }
  }

  /*
  * Method that will upload the base64 documents to pivotal and return a uploadID
  * */
  function uploadDocuments() {
    const uploadPromises = [];
    Object.entries(filesBase64).forEach(([key, file]) => {
      if(file !== ""){
        const requestData = {
          "uploadFileBase64": file
        };

        const pivotalAttachmentApi = new PivotalAttachmentsApi(apiUrl, apiEnv, accessToken);
        const promise = pivotalAttachmentApi.callTaskUploadEndpoint(requestData, '_Espace_Partenaire')
          .then(response => {
            return {[key + '__UploadID']: response.payload.uploadID};
          })
          .catch(error => {
            console.error('Error during file upload:', error);
          });
        uploadPromises.push(promise);
      }
    });

    // Return a Promise that resolves when all fetch calls are completed
    return Promise.all(uploadPromises)
      .then((response) => {
        const mergedData = Object.assign({}, files, ...response);
        setFiles(mergedData);
        setUpdateForm3(true); // Return true after all fetch calls are finished
      }).catch(error => {
        console.error('Error during file upload:', error);
      });
  }

  /*
  * Method that handle the change on the input file type
  * */
  function handleFileInputUpload(event) {
    const file = event.target.files[0];
    const uploadName = event.target.name;
    const lastModifiedDateTime = new Date(file.lastModifiedDate);
    const fileInfo = {
      [`${uploadName}`]: file.name,
      [`RN_${uploadName}_FN`]: file.name.split('.').slice(0, -1).join('.'),
      [`RN_${uploadName}_FZ`]: file.size,
      [`RN_${uploadName}_ED`]: `${lastModifiedDateTime.getMonth() + 1}/${lastModifiedDateTime.getDate()}/${lastModifiedDateTime.getFullYear()}`,
      [`RN_${uploadName}_ET`]: `${lastModifiedDateTime.getHours()}:${lastModifiedDateTime.getMinutes()}:${lastModifiedDateTime.getSeconds()}`,
      [`RN_${uploadName}_EX`]: file.type.split("/")[1]
    };
    setFiles({...files, ...fileInfo});
    convertDocumentToBase64(file, uploadName);
    if (uploadName === "Formation_Plan") {
      setTrainingFileName(file.name);
    }
    if (uploadName === "Evaluation") {
      setEvaluationFileName(file.name);
    }
    if (uploadName === "EP_Doc_Comp_1") {
      setEP_Doc_Comp_1FileName(file.name);
    }
    if (uploadName === "EP_Doc_Comp_2") {
      setEP_Doc_Comp_2FileName(file.name);
    }
    if (uploadName === "EP_Doc_Comp_3") {
      setEP_Doc_Comp_3FileName(file.name);
    }
    if (uploadName === "EP_Doc_Comp_4") {
      setEP_Doc_Comp_4FileName(file.name);
    }
  }

  /*
  * Method that deletes a key from the contactData (used for file input's file info)
  * */
  function deletefileInfoKey(param) {
    const newFiles = files;
    delete newFiles[param];
    setFiles(newFiles);
  };

  /*
  * Method triggered when a user clicks to delete the file from an input
  * */
  function handleResetFileInput(e) {
    e.preventDefault();
    const customFile = e.target.closest('.file-custom');
    const inputFile = customFile.querySelector('input[type="file"]');
    const inputId = inputFile.id;
    // Clears the input and filename
    handleClearFileInput(inputId);
    if (inputId === "Formation_Plan") {
      setTrainingFileName("");
    }
    if (inputId === "Evaluation") {
      setEvaluationFileName("");
    }
    if (inputId === "EP_Doc_Comp_1") {
      setEP_Doc_Comp_1FileName("");
    }
    if (inputId === "EP_Doc_Comp_2") {
      setEP_Doc_Comp_2FileName("");
    }
    if (inputId === "EP_Doc_Comp_3") {
      setEP_Doc_Comp_3FileName("");
    }
    if (inputId === "EP_Doc_Comp_4") {
      setEP_Doc_Comp_4FileName("");
    }
    const uploadName = inputFile.id;
    deletefileInfoKey(`RN_${uploadName}_FN`);
    deletefileInfoKey(`RN_${uploadName}_FZ`);
    deletefileInfoKey(`RN_${uploadName}_ED`);
    deletefileInfoKey(`RN_${uploadName}_ET`);
    deletefileInfoKey(`RN_${uploadName}_EX`);
    setFiles({...files, [`${uploadName}`]: false});
    setFilesBase64({...filesBase64, [`${uploadName}`]: ''});
  }

  function ResetFileInput(inputID) {
    const inputId = inputID;
    // Clears the input and filename
    handleClearFileInput(inputId);
    if (inputId === "Formation_Plan") {
      setTrainingFileName("");
    }
    if (inputId === "Evaluation") {
      setEvaluationFileName("");
    }
    if (inputId === "EP_Doc_Comp_1") {
      setEP_Doc_Comp_1FileName("");
    }
    if (inputId === "EP_Doc_Comp_2") {
      setEP_Doc_Comp_2FileName("");
    }
    if (inputId === "EP_Doc_Comp_3") {
      setEP_Doc_Comp_3FileName("");
    }
    if (inputId === "EP_Doc_Comp_4") {
      setEP_Doc_Comp_4FileName("");
    }

    deletefileInfoKey(`RN_${inputID}_FN`);
    deletefileInfoKey(`RN_${inputID}_FZ`);
    deletefileInfoKey(`RN_${inputID}_ED`);
    deletefileInfoKey(`RN_${inputID}_ET`);
    deletefileInfoKey(`RN_${inputID}_EX`);
    setFiles({...files, [`${inputID}`]: false});
    setFilesBase64({...filesBase64, [`${inputID}`]: ''});
  }

  /*
  * Reset the evaluation data if submit empty
  * */
  function handleResetFileEvaluation() {
    setEvaluationFileName("");

    const uploadName = 'Evaluation'
    handleClearFileInput('Evaluation');
    deletefileInfoKey(`RN_${uploadName}_FN`);
    deletefileInfoKey(`RN_${uploadName}_FZ`);
    deletefileInfoKey(`RN_${uploadName}_ED`);
    deletefileInfoKey(`RN_${uploadName}_ET`);
    deletefileInfoKey(`RN_${uploadName}_EX`);
    setFiles({...files, [`${uploadName}`]: false});
    setFilesBase64({...filesBase64, [`${uploadName}`]: ''});
  }


  /*
  * Method that call the method to convert the file into base64 and update the state value
  * */
  const convertDocumentToBase64 = async (file, uploadName) => {
    const base64 = await convertBase64(file);
    setFilesBase64({...filesBase64, [uploadName]: base64});
    setFileUploaded(true);
  };

  /*
  * Method that handle the radio button change
  * */
  function handleOnChangeRadioValues(event) {
    setIsSeparateFile(event.target.value === 'separateFile');
    ResetFileInput("Evaluation");
    ResetFileInput("EP_Doc_Comp_1");
    ResetFileInput("EP_Doc_Comp_2");
    ResetFileInput("EP_Doc_Comp_3");
    ResetFileInput("EP_Doc_Comp_4");
  }


  return (
    <main className="fournisseur recognition">

      <h1 id="step3">{window.Drupal.t('fournisseur.creation_form.page.title')}</h1>

      <CsfFournisseurRecognitionRenewalTitle
        isRenewal={isRenewal || hasPreviousRenewalEndDate}
        formData={form}/>

      <div className="content">

        <aside className="form-steps-legend">
          <ol>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(1)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step1')}</span></button>
            </li>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(2)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step2')}</span></button>
            </li>
            <li className="active"><span>{window.Drupal.t('fournisseur.creation_form.steps.step3')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step4')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step5')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step6')}</span></li>
          </ol>
        </aside>

        <div className="form-steps-content">
          <form onSubmit={submitFormStep3} id="form-step03">
            <fieldset>
              <legend className="visually-hidden">{window.Drupal.t('fournisseur.creation_form.page.title')}</legend>
              <div className="d-flex align-items-center justify-content-between">
                <div className="form-group file-row flex-grow-1">
                  <div className={`file-custom ${isRenewal && 'disabled'}`}>
                    <small
                      className="fake-label">{window.Drupal.t('fournisseur.creation_form.form.fields.file_training_plan')}</small>
                    <input type="text" className="file-name" name="" id="Formation_Plan_Text" value={trainingFileName}
                           style={{width: 1, height: 1, padding: 0, visibility: "hidden"}}/>
                    <input onChange={handleFileInputUpload} type="file" className="visually-hidden" id="Formation_Plan"
                           name="Formation_Plan" accept=".doc,.docx,.pdf" defaultValue="" disabled={isRenewal}/>
                    <label className={`no-style-label ${isRenewal ? 'disabled' : ''}`} htmlFor="Formation_Plan"
                           aria-label={`${window.Drupal.t('fournisseur.gestion.file.btn')}. ${window.Drupal.t('fournisseur.creation_form.form.upload.requirements')}`}>
                      {window.Drupal.t('fournisseur.gestion.file.btn')}
                      <span
                        className="sr-only"> {window.Drupal.t('fournisseur.creation_form.form.fields.file_training_plan')}</span>
                    </label>
                    <div className="selectedFile d-none">
                      <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')} :</span>
                      <span className="name"></span>
                      <a href="#" className={`removeFile ${isRenewal && 'd-none'}`} onClick={handleResetFileInput}
                         data-toggle="tooltip"
                         title={window.Drupal.t('fournisseur.gestion.file.deselected')}><i
                        className="icon icon-remove"></i></a>
                    </div>
                  </div>
                </div>
                <img className="file-side-tooltip yellow-tooltip" src="/themes/custom/tink/dist/assets/info-tooltip.svg"
                     title={window.Drupal.t('fournisseur.creation_form.form.upload.requirements')}
                     data-toggle="tooltip-wide" data-html="true" data-placement="left" alt="Information"/>
              </div>

              <div className="row"
                   style={{paddingTop: "1rem"}}>
                <div className="col-12 col-xl-6">
                  <div className="form-group">
                    <input onChange={handleOnChangeRadioValues} checked={!isSeparateFile} type="radio" name="radios1"
                           id="evaluation-questions"
                           value="sameFile"
                           disabled={isRenewal}/>
                    <label
                      htmlFor="evaluation-questions">{window.Drupal.t('fournisseur.creation_form.form.fields.rdo_eval_questions')}</label>
                  </div>
                </div>

                <div className="col-12 col-xl-6">
                  <div className="form-group">
                    <input onChange={handleOnChangeRadioValues} type="radio" name="radios1"
                           id="evaluation-in-separate-file" checked={isSeparateFile} value="separateFile"
                           disabled={isRenewal}/>
                    <label
                      htmlFor="evaluation-in-separate-file">{window.Drupal.t('fournisseur.creation_form.form.fields.rdo_seperate_file')}</label>
                  </div>
                </div>

              </div>

              <div className="form-group file-row no-yellow-tooltip"
                   style={{display: (form.Condition_With_Evaluation && isSeparateFile) ? "block" : "none"}}>
                <div className={`file-custom ${isRenewal && 'disabled'}`}>
                  <small
                    className="fake-label">{window.Drupal.t('fournisseur.creation_form.form.fields.file_evaluation')}</small>
                  <input type="text" className="file-name" name="" id="Evaluation_Text" value={evaluationFileName}
                         style={{width: 1, height: 1, padding: 0, visibility: "hidden"}}/>
                  <input onChange={handleFileInputUpload} type="file" className="visually-hidden" id="Evaluation"
                         name="Evaluation" accept=".doc,.docx,.pdf" defaultValue="" disabled={isRenewal}/>
                  <label className={`no-style-label ${!isSeparateFile || isRenewal ? 'disabled' : ''}`}
                         htmlFor="Evaluation">
                    {window.Drupal.t('fournisseur.gestion.file.btn')}
                  </label>
                  <div className="selectedFile d-none">
                    <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')} :</span>
                    <span className="name"></span>
                    <a href="#" className={`removeFile ${isRenewal && 'd-none'}`} onClick={handleResetFileInput}
                       data-toggle="tooltip"
                       title={window.Drupal.t('fournisseur.gestion.file.deselected')} disabled={isRenewal}><i
                      className="icon icon-remove"></i></a>
                  </div>
                </div>
              </div>

              <div className="form-group file-row no-yellow-tooltip"
                   style={{display: isSeparateFile ? "block" : "none"}}>
                <div className={`file-custom ${isRenewal && 'disabled'}`}>
                  <small
                    className="fake-label">{window.Drupal.t('fournisseur.creation_form.form.fields.file_eP_Doc_Comp_1')}</small>
                  <input type="text" className="file-name" name="" id="EP_Doc_Comp_1_Text" value={eP_Doc_Comp_1FileName}
                         style={{width: 1, height: 1, padding: 0, visibility: "hidden"}}/>
                  <input onChange={handleFileInputUpload} type="file" className="visually-hidden" id="EP_Doc_Comp_1"
                         name="EP_Doc_Comp_1" accept=".doc,.docx,.pdf" defaultValue="" disabled={isRenewal}/>
                  <label className={`no-style-label ${!isSeparateFile || isRenewal ? 'disabled' : ''}`}
                         htmlFor="EP_Doc_Comp_1">
                    {window.Drupal.t('fournisseur.gestion.file.btn')}
                  </label>
                  <div className="selectedFile d-none">
                    <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')} :</span>
                    <span className="name"></span>
                    <a href="#" className={`removeFile ${isRenewal && 'd-none'}`} onClick={handleResetFileInput}
                       data-toggle="tooltip"
                       title={window.Drupal.t('fournisseur.gestion.file.deselected')} disabled={isRenewal}><i
                      className="icon icon-remove"></i></a>
                  </div>
                </div>
              </div>

              <div className="form-group file-row no-yellow-tooltip"
                   style={{display: isSeparateFile ? "block" : "none"}}>
                <div className={`file-custom ${isRenewal && 'disabled'}`}>
                  <small
                    className="fake-label">{window.Drupal.t('fournisseur.creation_form.form.fields.file_eP_Doc_Comp_2')}</small>
                  <input type="text" className="file-name" name="" id="EP_Doc_Comp_2_Text" value={eP_Doc_Comp_2FileName}
                         style={{width: 1, height: 1, padding: 0, visibility: "hidden"}}/>
                  <input onChange={handleFileInputUpload} type="file" className="visually-hidden" id="EP_Doc_Comp_2"
                         name="EP_Doc_Comp_2" accept=".doc,.docx,.pdf" defaultValue="" disabled={isRenewal}/>
                  <label className={`no-style-label ${!isSeparateFile || isRenewal ? 'disabled' : ''}`}
                         htmlFor="EP_Doc_Comp_2">
                    {window.Drupal.t('fournisseur.gestion.file.btn')}
                  </label>
                  <div className="selectedFile d-none">
                    <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')} :</span>
                    <span className="name"></span>
                    <a href="#" className={`removeFile ${isRenewal && 'd-none'}`} onClick={handleResetFileInput}
                       data-toggle="tooltip"
                       title={window.Drupal.t('fournisseur.gestion.file.deselected')}><i
                      className="icon icon-remove"></i></a>
                  </div>
                </div>
              </div>

              <div className="form-group file-row no-yellow-tooltip"
                   style={{display: (eP_Doc_Comp_1FileName !== '' || eP_Doc_Comp_2FileName !== '' || eP_Doc_Comp_3FileName !== '') && isSeparateFile ? "block" : "none"}}>
                <div className={`file-custom ${isRenewal && 'disabled'}`}>
                  <small
                    className="fake-label">{window.Drupal.t('fournisseur.creation_form.form.fields.file_eP_Doc_Comp_3')}</small>
                  <input type="text" className="file-name" name="" id="EP_Doc_Comp_3_Text" value={eP_Doc_Comp_3FileName}
                         style={{width: 1, height: 1, padding: 0, visibility: "hidden"}}/>
                  <input onChange={handleFileInputUpload} type="file" className="visually-hidden" id="EP_Doc_Comp_3"
                         name="EP_Doc_Comp_3" accept=".doc,.docx,.pdf" defaultValue="" disabled={isRenewal}/>
                  <label className={`no-style-label ${!isSeparateFile || isRenewal ? 'disabled' : ''}`}
                         htmlFor="EP_Doc_Comp_3">
                    {window.Drupal.t('fournisseur.gestion.file.btn')}
                  </label>
                  <div className="selectedFile d-none">
                    <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')} :</span>
                    <span className="name"></span>
                    <a href="#" className={`removeFile ${isRenewal && 'd-none'}`} onClick={handleResetFileInput}
                       data-toggle="tooltip"
                       title={window.Drupal.t('fournisseur.gestion.file.deselected')} disabled={isRenewal}><i
                      className="icon icon-remove"></i></a>
                  </div>
                </div>
              </div>

              <div className="form-group file-row no-yellow-tooltip"
                   style={{display: (((eP_Doc_Comp_1FileName !== '' && eP_Doc_Comp_2FileName !== '') || eP_Doc_Comp_3FileName !== '' || eP_Doc_Comp_4FileName !== '')) && isSeparateFile ? "block" : "none"}}>
                <div className={`file-custom ${isRenewal && 'disabled'}`}>
                  <small
                    className="fake-label">{window.Drupal.t('fournisseur.creation_form.form.fields.file_eP_Doc_Comp_4')}</small>
                  <input type="text" className="file-name" name="" id="EP_Doc_Comp_4_Text" value={eP_Doc_Comp_4FileName}
                         style={{width: 1, height: 1, padding: 0, visibility: "hidden"}}/>
                  <input onChange={handleFileInputUpload} type="file" className="visually-hidden" id="EP_Doc_Comp_4"
                         name="EP_Doc_Comp_4" accept=".doc,.docx,.pdf" defaultValue="" disabled={isRenewal}/>
                  <label className={`no-style-label ${!isSeparateFile || isRenewal ? 'disabled' : ''}`}
                         htmlFor="EP_Doc_Comp_4">
                    {window.Drupal.t('fournisseur.gestion.file.btn')}
                  </label>
                  <div className="selectedFile d-none">
                    <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')} :</span>
                    <span className="name"></span>
                    <a href="#" className={`removeFile ${isRenewal && 'd-none'}`} onClick={handleResetFileInput}
                       data-toggle="tooltip"
                       title={window.Drupal.t('fournisseur.gestion.file.deselected')} disabled={isRenewal}><i
                      className="icon icon-remove"></i></a>
                  </div>
                </div>
              </div>

              <div className="row"
                   style={{paddingTop: "2rem", display: form.Condition_With_Evaluation ? "flex" : "none"}}>
                <div className="col-12 col-md-8">
                  <div className="form-group d-flex align-items-center">
                    <input type="checkbox"
                           checked={isDifficultyChecked}
                           onChange={(event) => setIsDifficultyChecked(event.target.checked)}
                           id="difficulty-level" name="difficulty-level"/>
                    <label
                      htmlFor="difficulty-level">{window.Drupal.t('fournisseur.creation_form.form.fields.chk_eval_difficulty')}</label>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group" style={{visibility: isDifficultyChecked ? "visible" : "hidden"}}>
                    <label
                      htmlFor="passing-grade">{window.Drupal.t('fournisseur.creation_form.form.fields.pass_grade')}(%)*</label>
                    <input type="number"
                           defaultValue={form.Cycle__Secondary?.[form.Cycle__Secondary.length - 1]?.Passing_Grade || "60"}
                           id="passing-grade" name="passing-grade" min="60" max="100"/>
                  </div>
                </div>
              </div>

              <p className="extra-info d-flex align-items-center justify-content-between">
                {window.Drupal.t('fournisseur.creation_form.form.fields.control_desc')} <img className="yellow-tooltip"
                                                                                             src="/themes/custom/tink/dist/assets/info-tooltip.svg"
                                                                                             title={window.Drupal.t('fournisseur.creation_form.form.desc.requirements')}
                                                                                             data-toggle="tooltip-wide"
                                                                                             data-html="true"
                                                                                             data-placement="left"
                                                                                             alt="Information"/>
              </p>

              <div className="form-group">
                <label
                  htmlFor="description">{window.Drupal.t('fournisseur.creation_form.form.fields.control_label')}*</label>
                <textarea name="description" id="description" className="form-textarea"
                          aria-label={`${window.Drupal.t('fournisseur.creation_form.form.fields.control_label')}. ${window.Drupal.t('fournisseur.creation_form.form.desc.requirements')}`}
                          defaultValue={form.Cycle__Secondary?.[form.Cycle__Secondary.length - 1]?.Activity_Participation_Control}></textarea>
              </div>

              <div className="row action-buttons">
                <div className="col text-center">
                  <button className="button btn-outlined btn-larger" type="button" onClick={() => handlePreviousStepClick()}>
                    {window.Drupal.t('fournisseur.previous.btn')}
                  </button>
                </div>
                <div className="col text-center">
                  <button className="button btn-larger" type="submit">
                    {window.Drupal.t('fournisseur.next.btn')}
                  </button>
                </div>
              </div>

            </fieldset>
          </form>
        </div>
      </div>

    </main>
  );
}

FournisseurRecognitionRequestStepThreeBlock.propTypes = {
  hasPreviousRenewalEndDate: PropTypes.bool,
  currentStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func,
  accessToken: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  updateForm: PropTypes.func.isRequired,
}
